import { useQuery } from '@tanstack/react-query';
import { useBlockchainManagementService } from './blockchain-management-service';
export const useManagementContractQuery = (options, customOptions) => {
    const blockchainManagementService = useBlockchainManagementService();
    return useQuery({
        ...options,
        ...customOptions,
        queryFn: () => options.queryFn(blockchainManagementService),
        queryKey: options.queryKey(),
    });
};
//# sourceMappingURL=query.js.map